import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const dataSlice = createSlice({
  name: "upsert-sla-answer-tags",
  initialState: initialState,
  reducers: {
    startUpsertSlaAnswerTags: (state) => {
      state.loading = true;
    },
    successUpsertSlaAnswerTags: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorUpsertSlaAnswerTags: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  startUpsertSlaAnswerTags,
  successUpsertSlaAnswerTags,
  errorUpsertSlaAnswerTags,
} = dataSlice.actions;

export default dataSlice.reducer;
